import { faFacebookSquare } from "@fortawesome/free-brands-svg-icons";
import {
  faClock,
  faEnvelope,
  faEye,
  faEyeSlash,
  faMapMarkerAlt,
  faPhone,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../css/JuanScope/ScopeLogin.css";
import "../../css/UserAdmin/Global.css";
import "../../css/UserAdmin/ForgotPassword.css";
import JuanEMSLogo from "../../images/JuanEMSlogo.png";
import SJDEFILogo from "../../images/SJDEFILogo.png";

function JuanISResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const { email, employeeID } = location.state || {};

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    if (!email || !employeeID) {
      navigate("/juan-is-login");
    }
  }, [email, employeeID, navigate]);

  const validateForm = () => {
    const newErrors = {};
    if (!newPassword) {
      newErrors.newPassword = "New password is required";
    } else if (newPassword.length < 8) {
      newErrors.newPassword = "Password must be at least 8 characters";
    }
    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm password is required";
    } else if (confirmPassword !== newPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/faculty/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Content-Type-Options": "nosniff",
          "X-XSS-Protection": "1; mode=block",
        },
        body: JSON.stringify({ employeeID, newPassword }),
      });

      const data = await response.json();

      if (!response.ok) {
        if (data.errorType === 'account_not_found') {
          toast.error("Account not found.");
        } else if (data.errorType === 'validation') {
          toast.error(data.message || "Invalid password format.");
        } else {
          toast.error(data.message || "Failed to reset password.");
        }
        return;
      }

      toast.success("Password reset successful! Redirecting to login...");
      setTimeout(() => {
        navigate("/juan-is-login");
      }, 2000);
    } catch (error) {
      console.error("Password reset error:", error);
      toast.error("Failed to connect to the server. Please check your network or try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleGoToLogin = () => {
    navigate("/juan-is-login");
  };

  const handleGoToHome = () => {
    navigate("/home");
  };

  return (
    <div className="splash-screen-container main">
      <ToastContainer />
      <div className="login-container">
        <div className="left-box">
          <img src={SJDEFILogo} alt="SJDEFI Logo" className="admin-logo" />
          <div className="header-text">
            <h1>SAN JUAN DE DIOS EDUCATIONAL FOUNDATION, INC.</h1>
            <p className="motto">
              Where faith and reason are expressed in Charity.
            </p>
          </div>
          <h1 className="login-title">Information System Portal</h1>
        </div>
        <div className="right-box">
          <h1 className="login-title">Reset Password</h1>
          <p className="login-subtitle">
            Enter your new password for your account
          </p>
          <label className="input-label">New Password</label>
          <div className="juanis-login-password-container">
            <Input
              type={showPassword ? "text" : "password"}
              className="custom-input"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              status={errors.newPassword ? "error" : ""}
            />
            <button
              type="button"
              className="juanis-login-password-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </button>
          </div>
          {errors.newPassword && (
            <div className="error-message">{errors.newPassword}</div>
          )}

          <label className="input-label">Confirm Password</label>
          <div className="juanis-login-password-container">
            <Input
              type={showConfirmPassword ? "text" : "password"}
              className="custom-input"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              status={errors.confirmPassword ? "error" : ""}
            />
            <button
              type="button"
              className="juanis-login-password-toggle"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
            </button>
          </div>
          {errors.confirmPassword && (
            <div className="error-message">{errors.confirmPassword}</div>
          )}

          <div className="login-options">
            <Button type="link" onClick={handleGoToHome} style={{ padding: 0 }}>
              Go Back to Home
            </Button>
            <Button type="link" onClick={handleGoToLogin} style={{ padding: 0 }}>
              Back to Login
            </Button>
          </div>
          <Button
            type="ghost"
            className="login-btn"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? (
              <>
                <FontAwesomeIcon icon={faSpinner} spin className="spinner-icon" />
                <span>Processing...</span>
              </>
            ) : (
              "Reset Password"
            )}
          </Button>
        </div>
      </div>
      <footer className="juan-register-footer">
        <div className="juan-footer-left">
          <img src={JuanEMSLogo} alt="JuanEMS Logo" className="juan-footer-logo" />
          <div className="juan-footer-text">
            <h1>JuanEMS - Information System Portal</h1>
            <p className="juan-footer-motto">
              2025. San Juan De Dios Educational Foundation Inc.
            </p>
          </div>
        </div>
        <div className="juan-footer-content">
          <div className="juan-footer-links">
            <a href="/about" className="footer-link">About</a>
            <span className="footer-link-separator"> | </span>
            <a href="/terms-of-use" className="footer-link">Terms of Use</a>
            <span className="footer-link-separator"> | </span>
            <a href="/privacy" className="footer-link">Privacy</a>
          </div>
          <a
            href="https://www.facebook.com/SJDEFIcollege"
            target="_blank"
            rel="noopener noreferrer"
            className="juan-footer-social-link"
          >
            <FontAwesomeIcon icon={faFacebookSquare} className="juan-social-icon" />
            <div className="juan-social-text">
              <span className="juan-social-find">Find us on</span>
              <span className="juan-social-platform">Facebook</span>
            </div>
          </a>
          <div className="juan-footer-contact-container">
            <div className="juan-contact-title">
              <FontAwesomeIcon icon={faPhone} />
              <span>CONTACT US</span>
            </div>
            <div className="juan-contact-items">
              <div className="juan-contact-item">
                <FontAwesomeIcon icon={faMapMarkerAlt} />
                <span>2772 Roxas Blvd., Pasay City, Philippines, 1300</span>
              </div>
              <div className="juan-contact-item">
                <FontAwesomeIcon icon={faPhone} />
                <span>+632 551-2763</span>
              </div>
              <div className="juan-contact-item">
                <FontAwesomeIcon icon={faEnvelope} />
                <span>
                  admission_office@sjdefi.edu.ph | registrarsoffice@sjdefi.edu.ph
                </span>
              </div>
              <div className="juan-contact-item">
                <FontAwesomeIcon icon={faClock} />
                <span>
                  Monday to Thursday - 7:00 AM to 5:00 PM | Friday - 7:00 AM to 4:00 PM
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default JuanISResetPassword;